export default __webpack_public_path__ + "static/media/120.414e6052.png";